module.exports = __webpack_public_path__ + "static/media/armor.ca415b3b.png";